import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mock';

const Services = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="services" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">Our Services</div>
        <div className="grid md:grid-cols-2 gap-8 items-start mb-14">
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight">
            How We Help Your <br /> Business Grow
          </h2>
          <p className="text-slate-400 max-w-md md:mt-4">
            Explore how intelligent cloud systems streamline operations, improve efficiency, and support scalable business growth.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 h-auto md:h-[520px]">
          {services.map((s, idx) => {
            const isActive = active === idx;
            return (
              <div
                key={s.id}
                onMouseEnter={() => setActive(idx)}
                onClick={() => {
                  setActive(idx);
                  if (s.link) {
                    window.open(s.link, '_blank', 'noopener,noreferrer');
                  }
                }}
                role={s.link ? 'link' : undefined}
                tabIndex={s.link ? 0 : undefined}
                onKeyDown={(e) => {
                  if (s.link && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    window.open(s.link, '_blank', 'noopener,noreferrer');
                  }
                }}
                className="relative overflow-hidden rounded-3xl cursor-pointer transition-all duration-500 ease-out border border-white/10 min-h-[300px] md:min-h-0 group"
                style={{ flex: isActive ? 2.4 : 0.7 }}
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/60 to-black/40"></div>

                <div className="relative h-full flex flex-col justify-end p-6">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className={`font-display text-white font-semibold leading-tight break-words ${isActive ? 'text-xl md:text-2xl' : 'text-base md:text-lg'}`}>
                      {s.title}
                    </h3>
                    {s.link ? (
                      <Link
                        to={s.link}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="h-8 w-8 rounded-full bg-amber-500/20 border border-amber-400/40 flex items-center justify-center shrink-0 hover:bg-amber-500/30 transition-colors"
                        aria-label={`Learn more about ${s.title}`}
                      >
                        <ArrowUpRight size={14} className="text-amber-200" />
                      </Link>
                    ) : (
                      <div className="h-8 w-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center shrink-0">
                        <ArrowUpRight size={14} className="text-white" />
                      </div>
                    )}
                  </div>

                  <div className={`overflow-hidden transition-all duration-500 ${isActive ? 'max-h-72 opacity-100 mt-3' : 'max-h-0 opacity-0'}`}>
                    <p className="text-slate-300 text-sm leading-relaxed">{s.description}</p>
                    <div className="mt-4 h-px bg-white/10"></div>
                    <div className="mt-4 grid grid-cols-2 gap-4">
                      {s.stats.map((st) => (
                        <div key={st.label}>
                          <div className="font-display text-2xl text-white font-semibold">{st.value}</div>
                          <div className="text-xs text-slate-400 mt-0.5">{st.label}</div>
                        </div>
                      ))}
                    </div>
                    {s.link && (
                      <Link
                        to={s.link}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="mt-4 inline-flex items-center gap-1.5 text-amber-300 hover:text-amber-200 text-sm font-medium"
                      >
                        Explore packages <ArrowUpRight size={14} />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
